export default __webpack_public_path__ + "media/images/front/about/point_1_img-b7b4f2ba692d67844b2d33dd82eb5069.jpg";